export default __webpack_public_path__ + "static/media/tile001.ae8ccaa4.jpeg";